import { render, staticRenderFns } from "./Biodata.vue?vue&type=template&id=16ec743d&"
import script from "./Biodata.vue?vue&type=script&lang=js&"
export * from "./Biodata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports